import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AutoRedirect = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Só redirecionar se não estiver carregando e tiver usuário
    if (loading || !user || !user.userType) {
      return;
    }

    const currentPath = location.pathname;
    
    // Se é student e está tentando acessar rota admin
    if (user.userType === 'student' && currentPath !== '/aluno') {
      console.log('🎓 Student tentando acessar rota admin, redirecionando para /aluno');
      navigate('/aluno', { replace: true });
      return;
    }
    
    // Se é admin e está tentando acessar rota student
    if (user.userType === 'admin' && currentPath === '/aluno') {
      console.log('👨‍💼 Admin tentando acessar rota student, redirecionando para dashboard');
      navigate('/', { replace: true });
      return;
    }
    
    // Se está na raiz e é student, redirecionar para /aluno
    if (user.userType === 'student' && currentPath === '/') {
      console.log('🎓 Student na raiz, redirecionando para /aluno');
      navigate('/aluno', { replace: true });
      return;
    }
    
    // Se está em /aluno e é admin, redirecionar para dashboard
    if (user.userType === 'admin' && currentPath === '/aluno') {
      console.log('👨‍💼 Admin em /aluno, redirecionando para dashboard');
      navigate('/', { replace: true });
      return;
    }
    
  }, [user, loading, location.pathname, navigate]);

  // Este componente não renderiza nada, apenas gerencia redirecionamentos
  return null;
};

export default AutoRedirect;
